<script>
export default {
  name: 'InfoBox',
  props: {
    styles: {
      type: Object,
      default: function () {
        return {}
      },
    },
    data: {
      type: Object,
      required: true,
    },
    info: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data () {
    return {}
  },
}
</script>

<template>
  <div :class="$style.container">
    <div :class="[{ [$style.contentInfo]: info }, $style.content]">
      <BaseIcon
        v-if="data.icon"
        :class="$style.content__icon"
        :name="data.icon"
      />
      <p :class="$style.content__paragraph">
        {{ data.text }}
      </p>
    </div>

  </div>
</template>

<style lang="scss" module scoped>
@import '@design';

.container {
  position: relative;
  width: 100%;
}

.content {
  z-index: 1;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  width: 95%;
  padding: 1rem 0;
  margin: 0 auto;
  background-color: $options-color;
  border-radius: 15px;
  box-shadow: $bottom-box-shadow;


  &__icon {
    width: 1.3rem;
    height: 1.3rem;
    margin: 0 0 0.3rem 0.2rem;
    color: $orange-alert
  }

  &__paragraph {
    @extend %typography-large;

    margin-bottom: 0.5rem;
    color: white;
    width: 85%;
    font-weight: normal;
  }

  &:global(.v-enter-active) {
    transition: opacity 2.5s;
  }
  // stylelint-disable-next-line selector-class-pattern
  &:global(.v-enter) {
    opacity: 0;
  }

  &Info {
    background-color: $color-rt-cian-primary;
  }
}

.background {
  position: absolute;
  top: 0;
  left: 5%;
  z-index: 1;
  width: 90%;
  height: 100%;
  margin: 0 auto;
  background-color: #f8d877;
  border-radius: 15px;
  opacity: 0.2;
}
</style>
